import { Component } from '@angular/core';
import { AbstractAppComponent } from '@shared/components/abstracts/abstract-app.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent extends AbstractAppComponent {
  constructor() {
    super(`META.TITLE`, `META.DESCRIPTION`, true);
  }
}
